import styled from '@emotion/styled';

const TACDiv = styled.div({
  marginTop: '10px'
});

export default TACDiv;
